import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useContext,
} from "react";
import { Flip } from "number-flip";
import { DataContext } from "App";
import { getHourNum } from "utils/index";

type dataType = {
  name: string;
  key: "imp" | "count" | "mom" | "yoy";
  base: number; // 大概位数
  ref: React.RefObject<HTMLDivElement>;
  flip?: Flip;
  isPercent: boolean;
};

function getSvgBar({ barNum = 5, w = 5, h = 30, gap = 2 }) {
  const svgW = barNum * (w + gap) - gap;

  return (
    <svg
      className="inline-block align-baseline mr-2"
      width={`${svgW}px`}
      height={`${h}px`}
      viewBox={`0 0 ${svgW} ${h}`}
    >
      <defs>
        <linearGradient id="barColor" x1="0%" y1="100%" x2="0%" y2="0%">
          <stop offset="0%" style={{ stopColor: "#79bbff" }} />
          <stop offset="100%" style={{ stopColor: "#c6e9fa" }} />
        </linearGradient>
      </defs>
      {Array.from({ length: barNum }).map((el, i) => {
        const barH = h * (0.3 + 0.7 * Math.random());
        return (
          <rect
            x={i * (w + gap)}
            y={h - barH}
            width={w}
            height={barH}
            fill="url(#barColor)"
            key={i}
          ></rect>
        );
      })}
    </svg>
  );
}

function NumberFlip() {
  const appData = useContext(DataContext);

  const [numbers] = useState<dataType[]>([
    {
      name: "今日累计曝光",
      key: "imp",
      base: 1999999999,
      isPercent: false,
      ref: useRef(null),
    },
    {
      name: "正在进行活动数",
      key: "count",
      base: 9999,
      isPercent: false,
      ref: useRef(null),
    },
    {
      name: "环比增长",
      key: "mom",
      base: 9999,
      isPercent: true,
      ref: useRef(null),
    },
    {
      name: "同比增长",
      key: "yoy",
      base: 9999,
      isPercent: true,
      ref: useRef(null),
    },
  ]);

  useEffect(() => {
    numbers.forEach((d) => {
      if (!d.flip) {
        d.flip = new Flip({
          node: d.ref.current,
          from: d.base,
          duration: 1,
          delay: 0,
          direct: false,
          separator: d.isPercent ? "." : ",",
          separateEvery: d.isPercent ? 2 : 3,
        });
      }
    });
  }, [numbers]);

  useEffect(() => {
    numbers.slice(1, 4).forEach((d) => {
      d.flip?.flipTo({ to: Math.abs(appData?.total?.today?.[d.key]) || 0 });
    });

    let timer: NodeJS.Timeout;

    function setNum() {
      numbers[0].flip?.flipTo({
        to: getHourNum(
          appData?.total?.today?.[numbers[0].key],
          appData?.percent
        ),
      });
      timer = setTimeout(() => setNum(), 3000);
    }

    setNum();

    return () => clearTimeout(timer);
  }, [numbers, appData]);

  return (
    <Fragment>
      {numbers.map(({ name, ref, isPercent, key }, i) => (
        <div key={i} className="mb-2">
          {getSvgBar({
            barNum: !i ? 7 : 5,
            w: !i ? 6 : 4,
            h: !i ? 30 : 20,
            gap: !i ? 3 : 2,
          })}
          {isPercent && appData?.total?.today?.[key] < 0 && (
            <span
              className={`font-n ${!i ? "text-6xl" : "text-2xl"} color-title`}
            >
              -
            </span>
          )}
          <div
            className={`inline-block font-n ${!i ? "text-6xl" : "text-2xl"}`}
            style={{
              verticalAlign: "-0.32em",
            }}
            ref={ref}
          />
          {isPercent && (
            <span
              className={`font-n ${!i ? "text-6xl" : "text-2xl"} color-title`}
            >
              %
            </span>
          )}
          <div className={`${!i ? "text-2xl" : "text-xl"} font-s color-text`}>
            {name}
          </div>
        </div>
      ))}
    </Fragment>
  );
}

export default NumberFlip;
